import styled from 'styled-components';

export const Title = styled.div`
  color: var(--color-sleepunique-teal);
  border: none;
  background-color: transparent;
  font-size: 1rem;
  width: 100%;
  text-align: left;
  line-height: 1.375;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;

  ${({ theme }) => theme.breakpoints.minBp('tablet')} {
    display: grid;
    align-items: center;
    grid-template-columns: 2fr 4fr 1fr;
  }

  .text {
    font-weight: 300;
  }
`;
